import SharingActions, { SharingMessage } from '@eversports/klimt-patterns/SharingActions'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Heading from '@eversports/klimt-primitives/legacy/Heading'

import { Localized } from '../../../localization/react'
import InviteFriends from './InviteFriends'

interface Props {
  sharingMessage: SharingMessage
  eventId: string
}

const InviteFriendsDialogContent = ({ sharingMessage, eventId }: Props) => (
  <Stack gap={4}>
    <InviteFriends eventId={eventId} />
    <Heading is="h4" variant="small">
      <Localized id="share-it" />
    </Heading>
    <SharingActions sharingMessage={sharingMessage} />
  </Stack>
)

export default InviteFriendsDialogContent
